import React from 'react';

import { Wrapper as ButtonWrapper, withBlockTypeConfigProps, withBlockTypeConfigPropsV2, withModalVisibility } from '../common/Button.jsx';
import Defaults from '../layout/Defaults.jsx';
import Name from '../common/Name.jsx';
import { default as SubscribePopup } from './SubscribePopup.jsx';
import Utilities from '../common/Utilities.jsx';

// region SIGN UP BUTTON V1 (-- DEPRECATED Use `SignUpButtonV2` --)

function _SignUpButtonV1Component(props) {
    const config = props.config || {};
    return (
        <React.Fragment>
            <div style={props.style}>
                <props.buttonComponent
                    className="btn btn--outl btn--prim btn--md form__btn btn--whitelabel btn--signup"
                    hoverProps={props.hoverProps}
                    id="inquire-btn"
                    style={props.buttonStyle}
                    type="button"
                    onClick={props.onButtonClick}>
                    {props.display || Defaults.Block[Name.Block.SignUpButtonV1]}
                </props.buttonComponent>
            </div>
            {
                props.modalVisible &&
                <SubscribePopup config={config} sub={config.subdomain} visible={true} onClose={props.onModalClose} />
            }
        </React.Fragment>
    );
}
const SignUpButtonV1Component = withBlockTypeConfigProps(withModalVisibility(_SignUpButtonV1Component));
const SignUpButtonV1 = { Component: SignUpButtonV1Component };

// region SIGN UP BUTTON V2

function _SignUpButtonV2Component(props) {
    const style = {}
    Utilities.copyObject(props.style, style);
    if (props.builder || props.disabled) {
        style.pointerEvents = 'none';
    }
    let className = 'btn btn--custom2 btn--signup btn--whitelabel btn--cta richText';
    if (props.className) {
        className += ` ${props.className}`;
    }
    return (
        <>
            <ButtonWrapper {...props}>
                <props.buttonComponent
                    className={className}
                    design={props.design}
                    hoverProps={props.hoverProps}
                    style={style}
                    type="button"
                    onClick={props.onButtonClick} />
            </ButtonWrapper>
            {
                props.modalVisible &&
                <SubscribePopup config={props.config} sub={props.config.subdomain} visible={true} onClose={props.onModalClose} />
            }
        </>
    );
}
const SignUpButtonV2Component = withBlockTypeConfigPropsV2(withModalVisibility(_SignUpButtonV2Component));
const SignUpButtonV2 = { Component: SignUpButtonV2Component };

const SignUpButtonV3Component = withBlockTypeConfigPropsV2(withModalVisibility(_SignUpButtonV2Component), undefined, true);
const SignUpButtonV3 = { Component: SignUpButtonV3Component };

export {
    SignUpButtonV3,

    // DEPRECATED
    SignUpButtonV1,
    SignUpButtonV2
}